export default __webpack_public_path__ + "static/media/xs.e80998ff.jpg";